(function () {
  'use strict';

  angular
    .module('admin.pack_maintenance.service', [])
    .factory('PackMaintenanceService', PackMaintenanceService);

  /** @ngInject */
  function PackMaintenanceService($http, $q, API) {

    function list(start, limit) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/sets/no_packs?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    return {
      list: list,
    };

  }

})();
